<template>
  <div class="container" v-loading="loading">
    <div class="title">感谢你的反馈，我们会积极改善，做出更好的服务的</div>
    <div class="body">
      <el-form ref="form" :model="form">
        <el-form-item>
          <div class="form-title">標題</div>
          <el-input
            v-model="form.title"
            placeholder="請輸入標題名稱"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱账号">
          <el-input
            v-model="form.email"
            placeholder="請輸入有效的郵箱賬號"
          ></el-input>
        </el-form-item>
        <el-form-item label="反馈信息">
          <el-input
            type="textarea"
            v-model="form.message"
            placeholder="請輸入您想反饋的內容~"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item class="footer">
          <div class="confirm-button" @click="onSubmit">提交</div>
          <div class="cancel-button">取消</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { feedBack } from "@api/user";
export default {
  data() {
    return {
      form: {
        title: "",
        email: "",
        message: ""
      },
      loading: false
    };
  },
  methods: {
    onSubmit() {
      if (this.form.title.length > 0 && this.form.message.length > 0) {
        this.loading = true;
        feedBack(this.form).then(res => {
          this.loading = false;
          this.$dialog.success(res.msg);
        });
      } else {
        this.$dialog.toast({ mes: "标题和反馈信息不能为空" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: rgb(72, 173, 241);
  height: 100%;
  padding: 0.25rem;
  .title {
    height: 40px;
    text-align: center;
    font-size: 15px;
    color: #fff;
  }
  .body {
    background-color: #fff;
    border-radius: 20px;
    padding: 0.4rem 0.3rem;
    .footer {
      .confirm-button {
        color: #fff;
        background-color: rgb(72, 173, 241);
        width: 100%;
        text-align: center;
        padding: 0.05rem 0;
        box-sizing: border-box;
        border-radius: 40px;
        margin-bottom: 0.5rem;
      }
      .cancel-button {
        color: rgb(158, 158, 158);
        width: 100%;
        text-align: center;
        padding: 0.05rem 0;
        border: 1px solid rgb(158, 158, 158);
        box-sizing: border-box;
        border-radius: 40px;
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
